// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__onzOB","content":"RecentSearches_content__rSdsY"};